"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHivemind = useHivemind;
var _react = require("react");
/**
 * Query Hivemind for the variant result of a given experiment and set the result to React state
 *
 * @param {Window|Object} target Browser window object or fallback
 * @param {Object} opt Options
 * @param {String} opt.experimentId The experiment ID
 * @param {String} opt.stateFieldName The name of the React state field to store the result in
 * @param {Object} [opt.attributes] An optional object to to pass along attributes
 * for split.io to calculate the variant ID. If none pass {}
 * @returns {Object} experiment settings
 * @public
 */
function useHivemind(target) {
  let {
    experimentId,
    stateFieldName,
    attributes = {}
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const [experiment, setExperiment] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (!(target !== null && target !== void 0 && target.hivemind) || !experimentId || !stateFieldName) return;
    target.hivemind.getClient().then(client => {
      const {
        cohorts
      } = client.getCohorts({
        experiments: [experimentId],
        attributes
      });
      if (!cohorts || !cohorts[experimentId]) return;
      setExperiment({
        [stateFieldName]: cohorts[experimentId].cohortId
      });
    });
  }, [experimentId, stateFieldName, attributes, target === null || target === void 0 ? void 0 : target.hivemind]);
  return experiment;
}